/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_LocationInputs */

const cs_enum_location = /** @type {(inputs: Enum_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita`)
};

const en_enum_location = /** @type {(inputs: Enum_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

/**
* | output |
* | --- |
* | "Location" |
*
* @param {Enum_LocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_location = /** @type {((inputs?: Enum_LocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_LocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_location(inputs)
	return cs_enum_location(inputs)
});